import { ResponsiveLine } from "@nivo/line";
import { ResponsiveBar } from "@nivo/bar";
const data = [
  {
    id: "Math",
    color: "hsl(9, 70%, 50%)",
    data: [
      {
        x: "Jan",
        y: 50,
      },
      {
        x: "Fed",
        y: 30,
      },
      {
        x: "Mar",
        y: 61,
      },
      {
        x: "April",
        y: 4,
      },
      {
        x: "May",
        y: 45,
      },
    ],
  },
  {
    id: "English",
    color: "hsl(148, 70%, 50%)",
    data: [
      {
        x: "Jan",
        y: 70,
      },
      {
        x: "Fed",
        y: 40,
      },
      {
        x: "Mar",
        y: 65,
      },
      {
        x: "April",
        y: 34,
      },
      {
        x: "May",
        y: 65,
      },
    ],
  },
  {
    id: "A110",
    color: "hsl(38, 70%, 50%)",
    data: [
      {
        x: "Jan",
        y: 80,
      },
      {
        x: "Fed",
        y: 11,
      },
      {
        x: "Mar",
        y: 90,
      },
      {
        x: "April",
        y: 73,
      },
      {
        x: "May",
        y: 44,
      },
    ],
  },
  {
    id: "Phy",
    color: "hsl(11, 70%, 50%)",
    data: [
      {
        x: "Jan",
        y: 23,
      },
      {
        x: "Fed",
        y: 74,
      },
      {
        x: "Mar",
        y: 62,
      },
      {
        x: "April",
        y: 55,
      },
      {
        x: "May",
        y: 44,
      },
    ],
  },
  {
    id: "Math 101",
    color: "rgb(255, 115, 29)",
    data: [
      {
        x: "Jan",
        y: 95,
      },
      {
        x: "Fed",
        y: 11,
      },
      {
        x: "Mar",
        y: 69,
      },
      {
        x: "April",
        y: 70,
      },
      {
        x: "May",
        y: 40,
      },
    ],
  },
];

export const MyResponsiveLine = () => (
  <ResponsiveLine
    data={data}
    margin={{ top: 20, right: 20, bottom: 80, left: 40 }}
    xScale={{ type: "point" }}
    yScale={{
      type: "linear",
      min: "0",
      max: "100",
      stacked: false,
      reverse: false,
    }}
    yFormat=" >-.2f"
    axisTop={null}
    axisRight={null}
    axisBottom={{
      orient: "bottom",
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      
      legendOffset: 36,
      legendPosition: "middle",
    }}
    axisLeft={{
      orient: "left",
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      
      legendOffset: -40,
      legendPosition: "middle",
    }}
    pointSize={10}
    pointColor={{ theme: "background" }}
    pointBorderWidth={2}
    pointBorderColor={{ from: "serieColor" }}
    pointLabelYOffset={-12}
    enableArea={true}
    useMesh={true}
    legends={[
      {
        anchor: "bottom",
        direction: "row",
        justify: false,
        translateX: 100,
        translateY: 0,
        itemsSpacing: 0,
        itemDirection: "left-to-right",
        itemWidth: 70,
        itemHeight: -80,
        itemOpacity: 0.75,
        symbolSize: 12,
        symbolShape: "circle",
        symbolBorderColor: "rgba(0, 0, 0, .5)",
        effects: [
          {
            on: "hover",
            style: {
              itemBackground: "rgba(0, 0, 0, .03)",
              itemOpacity: 1,
            },
          },
        ],
      },
    ]}
  />
);

const data2 = [
  {
    "country": "AD",
    "hot dog": 199,
    "hot dogColor": "hsl(123, 70%, 50%)",
    "burger": 135,
    "burgerColor": "hsl(234, 70%, 50%)",
    
  },
  {
    "country": "AE",
    "hot dog": 117,
    "hot dogColor": "hsl(253, 70%, 50%)",
    "burger": 30,
    "burgerColor": "hsl(37, 70%, 50%)",

  },
  {
    "country": "AF",
    "hot dog": 173,
    "hot dogColor": "hsl(235, 70%, 50%)",
    "burger": 104,
    "burgerColor": "hsl(223, 70%, 50%)",
   
  },
  {
    "country": "AG",
    "hot dog": 190,
    "hot dogColor": "hsl(19, 70%, 50%)",
    "burger": 71,
    "burgerColor": "hsl(214, 70%, 50%)",
   
  },
  {
    "country": "AI",
    "hot dog": 134,
    "hot dogColor": "hsl(300, 70%, 50%)",
    "burger": 137,
    "burgerColor": "hsl(292, 70%, 50%)",

  },
 
]
export const MyResponsiveBar = () => (
  <ResponsiveBar
    data={data2}
    keys={["hot dog", "burger", "sandwich", "kebab", "fries", "donut"]}
    indexBy="country"
    margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
    innerPadding={1}
    minValue={0}
    maxValue={100}
    groupMode="grouped"
    valueScale={{ type: "linear" }}
    indexScale={{ type: "band", round: true }}
    colors={{ scheme: "purple_blue_green" }}
    defs={[
      {
        id: "dots",
        type: "patternDots",
        background: "inherit",
        color: "#38bcb2",
        size: 4,
        padding: 1,
        stagger: true,
      },
      {
        id: "lines",
        type: "patternLines",
        background: "inherit",
        color: "#eed312",
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
      },
    ]}
    fill={[
      {
        match: {
          id: "fries",
        },
        id: "dots",
      },
      {
        match: {
          id: "sandwich",
        },
        id: "lines",
      },
    ]}
    borderColor={{
      from: "color",
      modifiers: [["darker", "1.6"]],
    }}
    axisTop={null}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "country",
      legendPosition: "middle",
      legendOffset: 32,
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "food",
      legendPosition: "middle",
      legendOffset: -40,
    }}
    labelSkipWidth={12}
    labelSkipHeight={12}
    labelTextColor={{ theme: "background" }}
    legends={[
      {
        dataFrom: "keys",
        anchor: "bottom-right",
        direction: "column",
        justify: false,
        translateX: 120,
        translateY: 0,
        itemsSpacing: 2,
        itemWidth: 100,
        itemHeight: 20,
        itemDirection: "left-to-right",
        itemOpacity: 0.85,
        symbolSize: 20,
        effects: [
          {
            on: "hover",
            style: {
              itemOpacity: 1,
            },
          },
        ],
      },
    ]}
    role="application"
    ariaLabel="Nivo bar chart demo"
    barAriaLabel={function (e) {
      return e.id + ": " + e.formattedValue + " in country: " + e.indexValue;
    }}
  />
);
